module.exports = __webpack_public_path__ + "static/media/storage.d92bddfb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/equinixIcon/storage.svg
// module id = 1107
// module chunks = 49